import Button from "@/components/button"
import Modal from "@/components/modal"
import useCategoryRepos from "@/repositories/category"

import { useState } from "react"

import nprogress from 'nprogress'
import axios from "axios"
import toast from "react-hot-toast"
import { useAuth } from "@/contexts/auth-context"
import { MessageCircle } from "@/components/icons/outline"

const Content = ({ data, onSubmit }) => {
    // Contexts
    const { user, token } = useAuth()

    // Forms
    const [content, setContent] = useState()

    const [errors, setErrors] = useState({})

    const handleSubmit = (e) => {
        e.preventDefault()

        nprogress.start()

        toast.loading("Loading", {
            id: "submit"
        })

        const url = `${process.env.REACT_APP_API_URL}/posts/${data?.post?.id}/reply`
        const payload = {
            content
        }

        axios.post(url, payload, { headers: { Authorization: `Bearer ${token}` } }).then((response) => {
            // Clear SWR cache
            // cache.clear()

            // Run on submit props
            onSubmit()

            // Show toast message
            toast.success(response.data.message, {
                id: "submit"
            })
        }).catch((error) => {
            // Assign validation data
            // if (error.response.status === 400) {
            //     setErrors(error.response.data.errors)
            // }

            // Show toast message
            toast.error(error.response.data.message, {
                ariaProps: {
                    superscript: error.response.status
                },
                id: "submit"
            })
        })
    }

    return (
        <form onSubmit={handleSubmit} className="flex flex-col w-full space-y-6">
            <div className="space-y-6 divide-y">
                {/* Post */}
                <div className="space-y-6">
                    <div className="flex flex-col justify-between w-full space-y-4 md:space-y-0 md:flex-row">
                        <div className="flex space-x-4">
                            <div className="relative">
                                <img className="w-10 h-10 rounded-xl" src={`https://ui-avatars.com/api/?name=${data.post.user.name}`} alt={`${data.post.user.name}'s Profile Picture`} />
                            </div>
                            <div className="flex flex-col items-start justify-center">
                                {/* Name */}
                                <p className="text-sm font-semibold">{data.post.user.name}</p>
                            </div>
                        </div>
                        <div className="px-3 py-1 text-xs font-medium text-blue-500 bg-blue-100 border border-blue-500 rounded-full w-fit h-fit">{data.post.category?.name}</div>
                    </div>
                    {/* Content */}
                    <div className="text-sm">
                        {data.post.content}
                    </div>
                </div>

                {/* Reply */}
                <div className="pt-6 space-y-6">
                    <div className="flex justify-between w-full">
                        <div className="flex space-x-4">
                            <div className="relative">
                                <img className="w-10 h-10 rounded-xl" src={`https://ui-avatars.com/api/?name=${user?.name}`} alt={`${user?.name}'s Profile Picture`} />
                            </div>
                            <div className="flex flex-col items-start justify-center">
                                {/* Name */}
                                <p className="text-sm font-semibold">{user?.name}</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <input required onChange={(e) => setContent(e.target.value)} value={content} type="text" placeholder={`Reply to ${data.post.user.name}...`} className="w-full text-sm focus:outline-none" />
                    </div>
                </div>
            </div>
            <div className="flex items-center justify-between">
                <div></div>
                <Button type="submit">
                    <div className="text-sm font-semibold">Submit</div>
                </Button>
            </div>
        </form>
    )
}

export default function CreateReply({ data, onSubmit, label }) {
    const [isOpen, setIsOpen] = useState(false)

    const openModal = () => {
        setIsOpen(true)
    }

    const closeModal = () => {
        setIsOpen(false)
    }

    const handleSubmit = () => {
        onSubmit()
        closeModal()
    }

    return (
        <>
            <button onClick={(e) => { e.stopPropagation(); openModal() }} className="flex items-center space-x-2">
                <MessageCircle />
                <span>
                    <p>{label}</p>
                </span>
            </button>
            <Modal title="Reply Post" size="2xl" onClose={() => closeModal()} isOpen={isOpen} content={<Content data={data} onSubmit={handleSubmit} />} />
        </>
    )
}